import request from "@/request/confJs/request";
import { API_ENDPOINTS } from "@/config/api";
import { normalizeFileUrl } from "@/utils/fileUrl";

export function uploadFile(formData) {
  return request({
    url: API_ENDPOINTS.file.upload,
    method: "POST",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
}



export function uploadAvatar(formData) {
  return request({
    url: API_ENDPOINTS.file.uploadAvatar,
    method: "POST",
    data: formData,
    headers: { "Content-Type": "multipart/form-data", isToken: false },
  });
}

export function resolveUploadedFile(response) {
  const payload = response?.data;
  if (payload && typeof payload === "object") {
    return {
      key: payload.key || "",
      // 相对 URL 可立即预览，又不会绑定部署域名。
      url: normalizeFileUrl(payload.key || payload.url || ""),
      originalName: payload.originalName || "",
      contentType: payload.contentType || "",
      size: Number(payload.size) || 0,
      sha256: payload.sha256 || "",
    };
  }
  const legacyValue = payload || response?.message || "";
  return { key: String(legacyValue), url: normalizeFileUrl(legacyValue) };
}

export const resolveUploadedFileUrl = (response) => resolveUploadedFile(response).url;
